export const getGroupRisksSuccess = (data) => ({
    type: 'GROUP_RISKS_RECEIVED',
    payload: data
    
});